import React from 'react';
import { useField, connect } from 'formik';

import ChipAutocomplete from '../ChipAutocomplete';

const FormikChipAutocomplete = ({
  value = [],
  getOptionKey = (option: any) => option,
  options: initialOptions,
  ...props
}: any) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [options, setOptions] = React.useState(initialOptions);
  const [field, meta] = useField({ ...props, value: value || [] });
  const error = meta.touched && meta.error;

  const currentValue = field.value || []; // todo idk how its possible for value to be undefined at first?

  return (
    <ChipAutocomplete
      {...field}
      {...props}
      options={options.filter((option: any) => !currentValue.includes(getOptionKey(option)))}
      value={options.filter((option: any) => currentValue.includes(getOptionKey(option)))}
      onChange={(e: any, selectedOptions: any[]) => {
        const optionKeys = options.map((_option: any) => getOptionKey(_option));
        const newOptions = selectedOptions.filter((selectedOption) => !optionKeys.includes(getOptionKey(selectedOption)));
        setOptions([...options, ...newOptions]);
        props.formik.setFieldValue(props.name, selectedOptions.map((option) => getOptionKey(option)));
      }}
      error={Boolean(error)}
      // helperText={error || props.helperText}
    />
  );
};

export default connect(FormikChipAutocomplete);
